import service from '@/store/services/blik-registrations-service';

const state = {
    list: {},
    blikRegistration: {},
    meta: {},
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, blikRegistration) => {
        state.blikRegistration = blikRegistration;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    getLatestLink({ commit, dispatch }, params) {
        return service.getLatestLink(params)
            .then((role) => { commit('SET_RESOURCE', role); });
    },

    createNewLink({ commit, dispatch }, params) {
        return service.createNewLink(params)
            .then((blikRegistration) => { commit('SET_RESOURCE', blikRegistration); });
    },

    getLocations({ commit, dispatch }, params) {
        return service.getLocations(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    getLocation({ commit, dispatch }, params) {
        return service.getLocation(params)
            .then((role) => { commit('SET_RESOURCE', role); });
    },

    getCashRegisterConfig({ commit, dispatch }, params) {
        return service.getCashRegisterConfig(params)
            .then((role) => { commit('SET_RESOURCE', role); });
    },

    setCashRegisterConfig({ commit, dispatch }, params) {
        return service.setCashRegisterConfig(params)
            .then((role) => { commit('SET_RESOURCE', role); });
    },

    eserviceBoardingRequest({ commit, dispatch }, params) {
        return service.eserviceBoardingRequest(params)
            .then((blikRegistration) => { commit('SET_RESOURCE', blikRegistration); });
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    blikRegistration: state => state.blikRegistration
};

const blikRegistrations = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default blikRegistrations;